import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function Navbar() {

  const [open, setOpen] = useState(false);

  // toggle button click
  const toggleMenu = () => {
    setOpen(!open);
  };

  // menu item click → close
  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <nav 
      className="navbar navbar-expand-lg sticky-top"
      style={{ 
        backgroundColor: "#e9edf5",
        borderBottom: "1px solid #ddd"
      }}
    >

      <div className="container">

        {/* LOGO */}
        <NavLink 
          className="navbar-brand d-flex align-items-center" 
          to="/"
          onClick={closeMenu}
        >
          <img
            src="/Images/LOGO.jpeg"
            alt="logo"
            style={{
              height: "70px",
              objectFit: "contain",
              marginRight: "10px"
            }}
          />

          <span style={{ 
            color: "#333", 
            fontSize: "22px", 
            fontWeight: "600"
          }}>
            Rithan Promoters
          </span>
        </NavLink>

        {/* MOBILE BUTTON */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* LINKS */}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>

          <ul className="navbar-nav ms-auto">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={closeMenu}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/About" onClick={closeMenu}>
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/Services" onClick={closeMenu}>
                Services
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/Projects" onClick={closeMenu}>
                Projects
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/Gallery" onClick={closeMenu}>
                Gallery
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/Contact" onClick={closeMenu}>
                Contact
              </NavLink>
            </li>

          </ul>

        </div>

      </div>

    </nav>
  );
}

export default Navbar;